import React from "react";
import logo from "../../Assets/logoMain.png";
import grid from "../../Assets/img/gridWhite.png";
import arrow from "../../Assets/downArrowMain.png";
import mainVideo from "../../Assets/mainVideo.mp4";
import { Link } from "react-router-dom";
import mainImage from "../../Assets/img/mainImage.jpg";
import { Navbar } from "../../Components/Navbar";
import sideImage1 from "../../Assets/img/sideImage1.jpg";
import sideImage2 from "../../Assets/img/sideImage2.png";
import AppFooter from "../../Components/AppFooter";
import { useNavigate } from "react-router-dom";
import { Link as Scroll } from "react-scroll";
import { authMenuSinap, noAuthMenuSinap } from "../../Utils/constants.api";
import useComponentVisible from "../../Context/hook/useComponentVisible";
import { useMediaQuery } from "react-responsive";

function MainHeader(props) {
  const navigate = useNavigate();
  const isTabLandOrMore = useMediaQuery({
    query: "(min-width: 56.26em)",
  });
  const isPhonePortOrMinor = useMediaQuery({
    query: "(max-width: 56.25em)",
  });
  const { isComponentVisible, toggle } = useComponentVisible(false);

  return (
    <>
      <div className="relative max-w-[100vw] max-h-fit h-full">
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "absolute",
            zIndex: 1,
            top: 0,
          }}
          className={`w-[100vw] h-full`}
        >
          <nav style={{ zIndex: 2 }} className={`mt-2 flex flex-row`}>
            <img
              className="w-60 absolute left-1/2  -translate-x-1/2"
              src={logo}
              alt=""
            />
            <button onClick={() => toggle(true)}>
              <img
                className="w-16 h-16 absolute right-12 top-10"
                src={grid}
                alt=""
              />
            </button>
          </nav>

          <div className="text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ">
            <h1 className="text-[#efae13] text-8xl font-bold">Explora</h1>
            <h2 className="text-[#efae13] text-8xl font-bold">
              Nuestro Catálogo
            </h2>
          </div>

          <button
            onClick={() => {
              navigate("/catalog");
            }}
            className="hover:bg-white hover:text-black absolute top-[65vh] left-1/2 transform -translate-x-1/2 mb-10 px-4 py-2 text-4xl tab-port:text-2xl text-[#EAEAEA] border-[#EAEAEA] border-2 rounded-xl"
          >
            Pulsa aquí
          </button>

          <div className=" absolute bottom-20 left-[46vw] tab-port:left-[49.1vw]">
            <Scroll
              to="main-content"
              spy={true}
              smooth={true}
              delay={100}
              offset={75}
              duration={700}
            >
              <img
                className="cursor-pointer w-20 tab-port:w-12"
                src={arrow}
                alt=""
              />
            </Scroll>
          </div>
        </div>
        <div
          style={{
            backgroundImage: isPhonePortOrMinor ? `url(${mainImage})` : "none",
            backgroundSize: isPhonePortOrMinor ? "cover" : "cover",
            backgroundPosition: isPhonePortOrMinor ? "center" : "none",
            position: "relative",
            zIndex: 0,
            right: 0,
            bottom: 0,
            maxWidth: "100vw",
            maxHeight: "100vh",
          }}
          className={`w-[100vw] h-[100vh] tab-port:h-fit`}
        >
          {isTabLandOrMore && (
            <video autoPlay muted required loop>
              <source src={props.bg} type="video/mp4" />
            </video>
          )}
        </div>
        <Navbar
          active={isComponentVisible}
          toggle={toggle}
          authMenu={authMenuSinap}
          noAuthMenu={noAuthMenuSinap}
        ></Navbar>
      </div>
    </>
  );
}
function MainArticle() {
  return (
    <main className="bg-white w-[100vw] mx-auto tab-port:h-[100vh] h-fit mb-20 text-center tab-port:text-left relative z-10">
      <div className="tab-port:top-1/2 tab-port:flex-row flex flex-col-reverse tab-port:left-1/2 tab-port:transform tab-port:-translate-x-1/2 tab-port:-translate-y-1/2 tab-port:absolute tab-port:w-[95vw] tab-port:h-[90vh]">
        <article className="tab-port:w-[65em] h-full">
          <div className="hidden flex-row  text-center  tab-port:flex tab-port:text-left">
            <div className="bg-[#003670] w-2 mr-3  mb-20">.</div>
            <p className="text-2xl text-[#5B5A5A]">
              Abogando por el medio ambiente
            </p>
          </div>
          <h1 className="font-base text-8xl leading-snug mb-10">
            Vive Experiencias <br />
            <span className="font-bold text-8xl">Inolvidables</span>
          </h1>
          <article className="mx-auto text-2xl font-light tab-port:w-full w-[90vw] text-[#5B5A5A] text-justify">
            Nuestra isla es un pequeño continente, posee diversos paisajes
            naturales que debemos proteger y utilizar de forma sostenible. Te
            invitamos a practicar el ecoturismo, a que conozcas las joyas
            escondidas de República Dominicana conectando con la naturaleza de
            una forma que jamás has hecho en tu vida. ¡Bienvenido al Sistema
            Nacional de Áreas Protegidas de República Dominicana!
            <br />
            <span className="text-2xl font-bold">
              Te invitamos a conocer Paraíso Natural.
            </span>
          </article>
          <Link to={"/catalog"}>
            <button className="mt-20 text-2xl rounded-lg font-bold px-16 py-6 text-white bg-[#003670]">
              Explora nuestras áreas protegidas y parques
            </button>
          </Link>
        </article>

        <div className="mx-auto mt-20 tab-port:mt-0 h-[30vh] w-[80vw] tab-port:w-[80em] tab-port:h-full relative tab-port:px-20">
          <img
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
            }}
            className="absolute top-0 w-[30em] h-[20em] tab-port:w-[60em] tab-port:h-[40em] z-20"
            src={sideImage1}
            alt=""
          />

          <img
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
            }}
            className="absolute bottom-10 right-0 w-[30em] h-[20em] tab-port:w-[60em] tab-port:h-[40em] z-20"
            src={sideImage2}
            alt=""
          />
        </div>
      </div>
    </main>
  );
}

function LandingPage() {
  return (
    <>
      <MainHeader bg={mainVideo} />
      <div id="main-content">
        <MainArticle />
      </div>
      <AppFooter />
    </>
  );
}

export default LandingPage;
